window.addEventListener('SITE_START', () => {
  const tableContainerEls = document.querySelectorAll('.table-container[data-m-width]');
  if (!tableContainerEls.length) return;

  tableContainerEls.forEach((el) => {
    const table = el.querySelector('table');
    const mWidth = el.getAttribute('data-m-width');

    if (mWidth) {
      table.style.setProperty('--m-width', mWidth);
    }
  });
});

window.addEventListener('SITE_START', () => {
  // 각 <col>의 data-m-col-width 값 처리
  const applyMobileColWidths = () => {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    document.querySelectorAll('col[data-m-col-width]').forEach((col) => {
      const mobileWidth = col.getAttribute('data-m-col-width');
      const defaultWidth = col.getAttribute('data-default-width'); // 나중 복원용

      if (isMobile) {
        // mobile: data-m-col-width 적용
        if (mobileWidth) col.style.width = mobileWidth;
      } else {
        // desktop: 원래 width 복원
        if (defaultWidth) col.style.width = defaultWidth;
        else col.style.removeProperty('width');
      }
    });
  };

  // 초기 실행 + 리사이즈 감지
  applyMobileColWidths();
  window.addEventListener('resize', applyMobileColWidths);
});

// 커스텀 스크롤바
window.addEventListener('SITE_START', () => {
  const tableContainersWithScrollbar = document.querySelectorAll('.table-container[data-scroll]');
  if (!tableContainersWithScrollbar.length) return;

  tableContainersWithScrollbar.forEach((container) => {
    const isNudgeVisible = container.getAttribute('data-nudge');
    const scrollWrapper = container.querySelector('.table-scroll-wrapper');

    if (!scrollWrapper) return;

    // 커스텀 스크롤바 요소 생성
    const customScrollbar = document.createElement('div');
    customScrollbar.className = 'custom-scrollbar';

    const scrollbarThumb = document.createElement('div');
    scrollbarThumb.className = 'scrollbar-thumb';
    customScrollbar.appendChild(scrollbarThumb);

    container.appendChild(customScrollbar);

    let isDragging = false;
    let startPos = 0;
    let startScrollPos = 0;

    const updateScrollbar = () => {
      const scrollWidth = scrollWrapper.scrollWidth;
      const clientWidth = scrollWrapper.clientWidth;
      const scrollLeft = scrollWrapper.scrollLeft;

      if (scrollWidth <= clientWidth) {
        customScrollbar.style.display = 'none';
        return;
      }

      customScrollbar.style.display = 'block';
      customScrollbar.style.width = `${clientWidth}px`;

      const thumbWidth = Math.max((clientWidth / scrollWidth) * clientWidth, 20);
      const thumbLeft = (scrollLeft / (scrollWidth - clientWidth)) * (clientWidth - thumbWidth);

      scrollbarThumb.style.width = `${thumbWidth}px`;
      scrollbarThumb.style.left = `${thumbLeft}px`;
    };

    const handleMouseDown = (e) => {
      isDragging = true;
      startPos = e.clientX;
      startScrollPos = scrollWrapper.scrollLeft;

      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      e.preventDefault();
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - startPos;
      const scrollWidth = scrollWrapper.scrollWidth;
      const clientWidth = scrollWrapper.clientWidth;
      const thumbWidth = parseFloat(scrollbarThumb.style.width);
      const maxThumbLeft = clientWidth - thumbWidth;
      const scrollRatio = deltaX / maxThumbLeft;
      const newScrollLeft = startScrollPos + scrollRatio * (scrollWidth - clientWidth);

      scrollWrapper.scrollLeft = Math.max(0, Math.min(newScrollLeft, scrollWidth - clientWidth));
    };

    const handleMouseUp = () => {
      isDragging = false;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    const handleTrackClick = (e) => {
      if (e.target === scrollbarThumb) return;

      const rect = customScrollbar.getBoundingClientRect();

      const clickX = e.clientX - rect.left;
      const thumbWidth = parseFloat(scrollbarThumb.style.width);
      const newThumbLeft = clickX - thumbWidth / 2;
      const maxThumbLeft = rect.width - thumbWidth;
      const scrollRatio = newThumbLeft / maxThumbLeft;
      const scrollWidth = scrollWrapper.scrollWidth;
      const clientWidth = scrollWrapper.clientWidth;

      scrollWrapper.scrollLeft = scrollRatio * (scrollWidth - clientWidth);
    };

    // 이벤트 리스너 등록
    scrollWrapper.addEventListener('scroll', () => {
      container.classList.add('--nudge-hide');
      updateScrollbar();
    });
    scrollbarThumb.addEventListener('mousedown', handleMouseDown);
    customScrollbar.addEventListener('click', handleTrackClick);

    // 리사이즈 시 스크롤바 업데이트
    window.addEventListener('resize', updateScrollbar);

    // 초기 스크롤바 설정
    updateScrollbar();
  });
});
